import { Facet } from '../models/Facet';
import { IBackgroundTaskQueue } from '../models/backgroundTasks/IBackgroundTaskQueue';
import { IOfflineCache } from '../operations/offlineCache';
import { KeyFacet } from '../models/KeyFacet';

export const backgroundTaskQueueFacet = new Facet<IBackgroundTaskQueue>('backgroundTaskQueue');

export const errorHandlerFacet = new Facet<(error: Error) => void>('errorHandler');

export const offlineCacheFacet: Facet<IOfflineCache> = new Facet('offlineCache');

export const configurationItemKeyFacet = new KeyFacet<{}>('configuration', {});

export const configurationItemKey = configurationItemKeyFacet.serialize({});

/**
 * Configuration facet to set the current default locale, as a fallback for data sources
 * which do not supply their own data locale.
 */
export const localeFacet: Facet<{
  language: string;
}> = new Facet('locale');

/**
 * Configuration facet to control cache pruning defaults.
 */
export const pruningConfigurationFacet: Facet<{
  pageDuration?: number;
  maxAge?: number;
}> = new Facet('pruningConfiguration');

/**
 * Configuration facet to enable the File Hover Card feature in the Details and Tiles lists.
 * @public
 */
export const enableFileHoverCardConfigurationFacet = new Facet<boolean>('enableFileHoverCard');

/**
 * Configuration facet to enable the Shimmered Details List.
 * @public
 */
export const enableShimmeredDetailsListConfigurationFacet = new Facet<boolean>('enableShimmeredDetailsList');

/**
 * Enable storage of larger backing items within [processResponse]
 * // TODO This needs to go in addon-sp
 */
export const enableSharePointBackingItemsFacet: Facet<boolean> = new Facet('enableSharePointBackingItems');

/**
 * Configuration facet to enable follow a Item feature in Details List.
 * @public
 */
export const enableFollowItemConfigurationFacet = new Facet<boolean>('enableFollowItem');

// DO NOT add configuration facets specific to add-ons. Only configure features here which are defined in Items View Core.